<template>
  <div id="user">
    <!-- <Navbar :title="$t('成员')">
      <template #right>
        <div class="right_icon">
          <div @click.stop="settingClick">
            <van-icon name="setting-o" color="var(--light)" size="22" />
          </div>
          <div @click.stop="commentClick">
            <van-icon name="comment-o" color="var(--light)" size="22" />
          </div>
        </div>
      </template>
</Navbar> -->
    <div class="userInfo_bar_wrap app_card">
      <div class="user_top">
        <img src="@/assets/ico/A6107.png" alt="">
        <div class="user_right">
          <div class="checkin" @click="itemClick('/CheckIn')">
            <van-icon name="notes-o" size="26" color="#fff" />
          </div>
          <div class="_lan" @click="show = true">{{ lanText }}</div>
        </div>
      </div>
      <div class="user_titleContent">
        <div class="user_contentLeft">
          <div class="contentLeft_img" @click="avatarClick">
            <Avatar :src="MemberInformation.userimg" :defaultSrc="require('@/assets/Img/myImg/head.png')" size="68" />
          </div>
          <div class="contentLeft_text">
            <template v-if="MemberInformation?.token">
              <div class="username">
                {{ MemberInformation.userphone || ''}}
              </div>
              <div class="userInfo">
                <div class="userInfo_id">
                  <span class="label">{{ "ID" }}:&nbsp;</span>
                  <span class="value">{{ MemberInformation.id || "" }}</span>
                </div>
                <div class="userInfo_id">
                  <span class="label">{{ $t("member.title.level") }}:&nbsp;</span>
                  <span class="value">
                    {{ MemberInformation.rank_title || "" }}
                  </span>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="username">{{ $t("newAdd.noLoginUserName") }}</div>
            </template>
            <div class="balance_bar">
              <div class="value">{{ $t('余额') }} {{ $money(MemberInformation.money || 0) }}</div>
            </div>
            <div class="balance_bars">
              <div class="value">USDT {{ $t('Hint.balance') }}：{{ Number(MemberInformation.usdt) || '0.00' }} USDT</div>
            </div>
            <!-- <div class="contentLeft_Vip" @click="showSign">
              <span class="label">{{ $t("member.title.level") }}:&nbsp;</span>
              <span class="value">
                {{ MemberInformation.rank_title || "" }}
              </span>
            </div> -->
            <!-- <div class="progress_">
              <div class="progress">
                <Progress :percentageStart="Number(MemberInformation.rank?.value || 0)"
                  :percentageEnd="Number(MemberInformation.rank?._next?.value || 0)" height="calc(8rem / 16)" isShow />
                {{ MemberInformation.rank?._next?.title }}
              </div>
            </div> -->
            <!-- <div class="contentLeft_Vip">
              <span class="label">{{ $t("mine.credit") }}:&nbsp;</span>
              <span class="value">
                {{ MemberInformation.credit || "" }}
              </span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="top_nav_bg app_card">
        <div class="top_nav_item" @click="itemClick('/vip')">
          <img src="../../assets/new/mine/vip.png" alt="">
          <span>{{ $t('VIP特权') }}</span>
        </div>
      </div>
      <div class="user_content">
        <div class="btns">
          <div class="btn_item app_card" v-for="item, index in btn" :key="index" @click="itemClick(item.url)">
            <div class="item_icon">
              <img :src="item.icon" class="icon" alt="" />
            </div>
            <div class="text">{{ $t(item.label) }}</div>
          </div>
        </div>
      </div>
    </div>
    <CellGroup class="group">
      <Cell :to="item.page" is-link class="cell_item" v-for="(item, index) in gridItemArr" @click="handleClick(item)"
        :key="index">
        <template #title>
          <div class="left_wrap">
            <!-- <i class="iconfont" :class="item.icon"></i> -->
            <!-- <img :src="item.icon" class="iconfonts"> -->
            <span class="label">{{ $t(item.label) }}</span>
          </div>
        </template>
      </Cell>
    </CellGroup>
    <!-- <div class="logout">
      <Btn block color="var(--btn_bg)" @click="logoutEvent">
        {{ MemberInformation.token ? $t("My.logout") : $t("newAdd.Login") }}
      </Btn>
    </div> -->
    <van-action-sheet v-model="show" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
    <!-- <Tabbar active="user" :language="language" /> -->
    <van-popup v-model="c2cShow" position="bottom" round>
      <c2cPop @close="c2cShow = false" :keyNum="keyNum" />
    </van-popup>
    <van-popup v-model="compensationShow" position="bottom" round>
      <Compensation @close="compensationShow = false" :key="keyNum" />
    </van-popup>
  </div>
</template>

<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  ActionSheet,
  Button,
  Image,
  Dialog,
  Toast,
  CellGroup,
  Button as Btn,
  // Progress
  Popup
} from "vant";
import Navbar from "@/components/JNav";
import Progress from '@/components/progress'
import Tabbar from "@/components/Tabbar";
import { REQUEST_API } from "@/http/api"; // 引入封装的axios
import { GET_USER_INFP, editAvatar } from "@/api";
import { maskMiddle } from "@/utils/common"
// 设置vant的多语言
import Cookies from "js-cookie";
import { countTime, getMyTime, deciTurnMoney } from "@/utils/tools";
import { Lans, getLanguage } from "@/i18n";
import ServiceBtn from "@/components/serviceBtn";
import { Avatar } from "@tt/components";
import c2cPop from "./components/c2c.vue"
import Compensation from "./components/compensation.vue"
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    Navbar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    CellGroup,
    Cell,
    Tabbar,
    ServiceBtn,
    Btn,
    Avatar,
    // [Progress.name]: Progress
    Progress,
    [Popup.name]: Popup,
    c2cPop,
    Compensation
  },
  data() {
    this.Lans = Lans;
    return {
      country: Cookies.get("language"),
      language: "",
      money: "",
      btn: [{
        label: '订金',
        icon: require('../../assets/new/mine/deposit.png'),
        url: '/new-recharge',
      }, {
        label: '转账',
        icon: require('../../assets/new/mine/transfer.png'),
        url: '/transfer',
      }, {
        label: 'My.withdrawal',
        icon: require('../../assets/new/mine/withdraw.png'),
        url: '/new-withdraw'
      }, {
        label: 'c2c',
        icon: require('../../assets/new/mine/c2c.png'),
        url: 'c2c',
      }, {
        label: '额度转换',
        icon: require('../../assets/new/mine/conver.png'),
        url: '/convert'
      }, {
        label: '申请包赔',
        icon: require('../../assets/new/mine/compensation.png'),
        url: 'Compensation',
      }],
      gridItemArr: [
        // {
        //   label: "促销代码",
        //   icon: require('../../assets/new/mine/promo.png'),
        //   page: "/promoCode",
        // },
        {
          label: "转账记录",
          icon: require('../../assets/new/mine/recharge_order.png'),
          page: "/AccountData?subtype=6",
        }, {
          label: "充值记录",
          icon: require('../../assets/new/mine/recharge_order.png'),
          page: "/recharge-list",
        }, {
          label: "page.withdrawRecord",
          icon: require('../../assets/new/mine/withdraw_order.png'),
          page: "/withdraw-list",
        }, {
          label: "账户记录",
          icon: require('../../assets/new/mine/account_order.png'),
          page: "/AccountData",
        }, {
          label: '安全中心',
          icon: require('../../assets/new/mine/security.png'),
          page: '/securityCenter'
        }, {
          label: `my.betRecord`,
          icon: require('../../assets/new/mine/bet_order.png'),
          page: "/cart",
        }, {
          label: `my.wallet`,
          icon: require('../../assets/new/mine/wallet.png'),
          page: "/walletList",
        }, {
          label: "My.language",
          icon: require('../../assets/new/mine/language.png'),
          callBack: () => {
            this.show = true;
          },
        }, {
          label: 'My.logout',
          callBack: () => {
            this.logoutEvent();
          }
        }],
      show: false,
      levelText: "",
      c2cShow: false,
      compensationShow: false,
      keyNum: 0,
    };
  },
  computed: {
    MemberInformation() {
      const userinfo = this.$store.getters.userInfo;
      return { ...userinfo, username: maskMiddle(userinfo.username) }
    },
    lanText() {
      let _obj = Lans.find(item => item.value == getLanguage());
      return _obj?.name || '';
    }
  },
  methods: {
    avatarClick() {
      if (this.MemberInformation.token) {
        this.$router.push('/Portrait')
      }else{
        this.$router.push('/login')
      }
    },
    settingClick() {
      this.itemClick("/PersonalCenter")
    },
    commentClick() {
      this.itemClick('/Message')
    },
    itemClick(url) {
      if (!url) return;
      if (url == 'Compensation') {
        this.keyNum++;
        this.compensationShow = true;
        return;
      }
      if (url == 'c2c') {
        this.keyNum++;
        this.c2cShow = true;
        return;
      }
      this.$router.push(url);
    },
    showSign() {
      if (this.MemberInformation?.sign) {
        Dialog.alert({
          message: this.MemberInformation.sign,
          confirmButtonText: this.$t("My.Button.Two")
        })
      }
    },
    handleClick(row) {
      if (!!row.callBack) {
        row.callBack();
      }
    },
    //会员说明
    explain() {
      this.$router.push({ name: "levelUpgrade" });
    },
    handleLinkBill() {
      this.$router.push("bill-record"); // 个人中心跳转-小饶
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value)
      Cookies.set('lang', e.value)
      Cookies.set('language', e.value)
      this.language = e.value;
      // this.$store.dispatch("getBanner");
      // this.$store.dispatch("getGameCategory");
      this.$store.dispatch("getCountry");
      this.show = false;
    },
    onClose() {
      this.show = false;
    },
    // 点击充值的按钮
    RechargeEvent() {
      Dialog.alert({
        title: this.$t('My.MemberInformation.Recharge'),
        message: this.$t('hint.lxkf'),
        showCancelButton: true,
        confirmButtonText: this.$t('Login.goLoginText'),
        cancelButtonText: this.$t('newAdd.Cancel')
      }).then(() => {
        this.$api.toService();
      }).catch(() => {
      });
      // this.$router.push("/new-recharge");
    },
    // 点击提现按钮
    WithdrawEvent() {
      this.$router.push({ name: "newWithdraw" });
    },
    // 注销的按钮
    logoutEvent() {
      let _this = this;
      if (_this.MemberInformation.token) {
        Dialog.confirm({
          // title: this.$t("My.quit"),
          message: this.$t("My.logoutEvent"),
          cancelButtonText: this.$t("My.Button.One"),
          confirmButtonText: this.$t("My.Button.Two"),
        }).then(() => {
          // let pwdState = _this.$cookie.get("the-pwd-state");
          let pwdObj = _this.$cookie.get("the-pwd-obj");
          _this.$store.dispatch('loginOut');
          // _this.$cookie.set("the-pwd-state", pwdState);
          _this.$cookie.set("the-pwd-obj", pwdObj);
          _this.$router.push("/login");
          // window.location.reload()
        }).catch(() => {

          // on cancel
        });
      } else {
        this.$router.push("/login");
      }
    },
    getDownloadUrl() {
      let url = {};
      let down = {
        id: 5,
        url: require("@/assets/icon/myself/download.png"),
        t: `My.download`,
        callBack: () => {
          window.location.href = url.android;
        },
      };
      this.$api.getNotice((res) => {
        if (res.appurl_android) {
          url.android = res.appurl_android;
          // this.gridItemArr.push(down);
        }
      });
    },
  },
  created() {
    this.$store.dispatch('getuserInfo')
    // this.getDownloadUrl();
  },
};
</script>

<style lang="less" scoped>
// @Color: #e23d6d;
@Color: var(--theme);
@button-border-radius: 20px;
@wrapPadding: calc(10rem / 16);
@comRadius: 10px;
// @comBG: linear-gradient(#093958, #022c47);
@comBG: var(--bg1);

// 弹性布局
.flex(@JC: center; @FW: nowrap; @AI: center; @FD: row) {
  display: flex;
  flex-wrap: @FW;
  flex-direction: @FD;
  justify-content: @JC;
  align-items: @AI;
}

// 文字超出省略号
.text-overflow(@num: 1) {
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: @num;
}

#user {
  min-height: calc(100vh - 28px);
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(24, 179, 141, .12), transparent 26%), radial-gradient(circle at left 25%, rgba(47, 110, 246, .1), transparent 22%), linear-gradient(180deg, #f7f9fc, #eef2f7);
  padding: 10px 10px 18px;

  .right_icon {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .progress_ {
    width: 60%;

    .progress_text {
      font-size: calc(14rem / 16);
      margin-left: calc(15rem / 16);
    }

    .progress {
      flex: 1;
      // padding: calc(7rem / 16) 0;
      display: flex;
      align-items: flex-end;
      font-size: calc(15rem / 16);

      // /deep/ .van-progress {
      //   flex: 1;
      //   margin-right: calc(7rem / 16);
      // }
    }
  }

  // background-color: rgb(245, 245, 245);
  .userInfo_bar_wrap {
    background: linear-gradient(135deg, #18b38df0, #2f6ef6e0);
    color: #fff;
    padding: 16px;

    .user_top {
      display: flex;
      align-items: center;
      justify-content: space-between;

      img {
        height: 36px;
        display: block;
        object-fit: contain;
      }
      .user_right{
        display: flex;
        align-items: center;
        gap: 10px;
        ._lan {
          font-size: 12px;
          font-weight: 700;
          opacity: .92;
        }
      }
    }

    .user_titleContent {
      display: flex;
      justify-content: space-between;
      margin: @wrapPadding 0;

      .user_contentLeft {
        flex: 1;
        display: flex;


        .contentLeft_text {
          margin-left: 10px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .username {
            font-size: calc(16rem / 16);
            display: flex;
            align-items: center;

            .rank {
              font-size: calc(16rem / 16);
              display: flex;
              align-items: center;

              img {
                width: 30px;
                display: block;
                margin-right: calc(8rem / 16);
                animation: moveUpDown 1s infinite alternate;
              }

              @keyframes moveUpDown {
                0% {
                  transform: translateY(-5px);
                }

                100% {
                  transform: translateY(5px);
                }
              }
            }
          }

          .userInfo {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-top: 10px;
            margin-bottom: 5px;
          }

          .userInfo_id {
            font-size: calc(14rem / 16);
          }

          .balance_bar {
            font-size: calc(16rem / 16);
            font-weight: 700;
            // background: linear-gradient(180deg, #ffe692, #ffd759 35.5%, #ffe58e 67.75%, #f79c17);
            // -webkit-background-clip: text;
            // background-clip: text;
            // -webkit-text-fill-color: transparent;
          }

          .balance_bars {
            font-size: 12px;
            margin-top: 4px;
          }
        }
      }

      .user_contentRight img {
        width: 7vw;
        height: 7vw;
      }
    }

    .top_nav_bg {
      margin: @wrapPadding;
      .flex(normal);
      flex-direction: column;
      padding: 14px 8px;
      text-align: center;
      background: #ffffff1f;
      border: 1px solid rgba(255, 255, 255, .12);
      color: #fff;
      cursor: pointer;
      border-radius: 18px;

      .top_nav_item {
        display: flex;
        align-items: center;
        gap: calc(10rem / 16);

        img {
          width: calc(35rem / 16);
          height: calc(35rem / 16);
          display: block;
        }

        span {
          color: var(--light);
          font-size: calc(14rem / 16);
          font-weight: 700;
        }
      }
    }

    // 中间
    .user_content {
      padding: 0 calc(12rem / 16) calc(11rem / 16);

      .btns {
        display: grid;
        padding-top: calc(4rem / 16);
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;

        .btn_item {
          .flex(normal);
          flex-direction: column;
          padding: 14px 8px;
          text-align: center;
          background: #ffffff1f;
          border: 1px solid rgba(255, 255, 255, .12);
          color: #fff;
          cursor: pointer;
          border-radius: 18px;

          .item_icon {
            .flex();

            .icon {
              width: calc(22rem / 16);
              height: calc(22rem / 16);
              display: block;
            }
          }

          .text {
            text-align: center;
            font-size: calc(13rem / 16);
            margin-top: calc(6rem / 16);
            font-weight: 600;
          }
        }
      }

      .balance_wrap {
        padding: 5vw;

        .balance_text {
          color: #b8ecff;
          margin-bottom: 5vw;
        }

        .contentCase_btns {
          .flex(space-around);

          .contentCase_btn {
            padding: 1.867vw 2vw;
            font-size: 3.733vw;
            line-height: normal;
            color: var(--textColor);
            text-align: center;
            border-radius: 7.467vw;
            background-color: @Color;
            // background: @comBG;
          }
        }

        .moey_num {
          color: @Color;
          font-size: 6.4vw;
          font-weight: 400;
        }
      }
    }
  }

  .group {
    margin-top: 10px;
    border-radius: @comRadius;
    @bg: #ffffffe0;
    overflow: hidden;
    background-color: transparent;

    &::after {
      border: none;
    }

    /deep/ .cell_item {
      .van-cell__right-icon {
        color: #969799;
      }

      &::after {
        border-color: var(--borderColor);
      }

      .left_wrap {
        display: flex;
        align-items: center;

        // .iconfonts {
        //   font-size: calc(26rem / 16);
        //   margin-right: calc(12rem / 16);
        //   color: var(--light);
        //   width: calc(26rem / 16);
        //   height: calc(26rem / 16);
        //   display: block;
        // }
      }
    }
  }

  // 第二个板块
  .caseT {
    margin-top: 5vw;
  }

  .logout {
    margin: @wrapPadding;
    margin-top: calc(35rem / 16);
    border-radius: 6px;
    overflow: hidden;
  }

  .van-grid-item__content {
    justify-content: start;
  }
}

.user_img {
  width: 15vw;
  border-radius: 10vw;
}
</style>